import React, { useEffect, useState } from "react";

import WelcomeContent from "./content";
import { FullScreenLoader } from "../components/Custom-Spinner";
import { callApi } from "../../utils/mainapp-api";
import "@ahrvocomply/ahrvo-comply-react-sdk-sandbox/dist/index.css";
import { CustomHeader } from "../../layout/header";
import { useLocation, useNavigate } from "react-router";
export default function Welcome({}) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const state = useLocation();

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    await addCss(
      "https://cdn.kycaml.systems/static/assets/css/dashlite.css?ver=1.9.2"
    );
    await addCss(
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    );
    await addCss(
      "https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,501;1,501&display=swap"
    );
    const response = await callApi("get", "welcome");
    if (response) {
      setData(response.data);
      localStorage.setItem("kycType", response.data.kycType);
      localStorage.setItem("first_name", response.data.user.first_name);
      localStorage.setItem("last_name", response.data.user.last_name);
      localStorage.setItem("email", response.data.user.email);
      localStorage.setItem("phone_number", response.data.phone_number);

      localStorage.setItem("walletUrl", response.data.walletUrl);
      localStorage.setItem("filesharingUrl", response.data.filesharingUrl);
      localStorage.setItem("chatUrl", response.data.chatUrl);
      localStorage.setItem("companyId", response.data.company_id);
      localStorage.setItem("apikey", response.data.apikey);
      localStorage.setItem("isMainAppUser", true);
      localStorage.setItem("country_code", response.data.country_code);
      setLoading(false);
      if (state?.state?.shouldStayOnWelcome) {
        return;
      }
    }
  };
  const addCss = async (src) => {
    var head = document.getElementsByTagName("HEAD")[0];

    // Create new link Element
    var link = document.createElement("link");

    // set the attributes for link element
    link.rel = "stylesheet";

    link.type = "text/css";

    link.href = src;
    head.appendChild(link);
    return new Promise((resolve, reject) => {
      link.addEventListener("load", () => {
        resolve(true);
      });
    });

    // Append link element to HTML head
  };
  if (loading) return <FullScreenLoader />;
  return (
    <div id="app">
      {/* <VideoCall /> */}
      <div className="nk-content">
        <CustomHeader />
      </div>
      <div className="nk-wrap">
        <WelcomeContent
          first_name={data.user.first_name}
          last_name={data.user.last_name}
          aml_and_pep_check={data.aml_and_pep_check}
          company_name={data.company_name}
          phone_number_verified={data.phone_number_verified}
          verify_liveness={data.verify_liveness}
          verify_fetch_match={data.verify_fetch_match}
          steps_completed={data.steps_completed}
          email_verified={data.email_verified}
          status={data.status}
          identity={data.identity}
          statusColor={data.statusColor}
          route={data.route}
          kycType={data.kycType}
          jwttokenForBiometric={data.jwttokenForBiometric}
          template_id={data.template_id}
          questionaire_completed={data.questionaire_completed}
          questionaire_data={data.questionaire_data}
        />
      </div>
    </div>
  );
}
